import * as React from "react";
import { Spinner, SpinnerType, SpinnerSize } from "office-ui-fabric-react";

export interface ProgressProps {
  title: string;
}

export default class Progress extends React.Component<ProgressProps> {
  render() {
    return (
      <section className="ms-welcome__progress ms-u-fadeIn500">
        <Spinner
          type={SpinnerType.large}
          label={"Loading..."}
          size={SpinnerSize.large}
          style={{ fontFamily: "Lato" }}
        />
      </section>
    );
  }
}
